export default "__VITE_ASSET__ebc91ae6__"